import ActividadTile from './ActividadTile';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaQrcode,
  FaTicketAlt,
  FaUsersCog,
  FaCogs,
  FaCalendarAlt,
  FaUserFriends,
  FaChartBar,
  FaRegStar,
  FaBuilding,
} from 'react-icons/fa';
import { RoleLayout, RoleGrid, RoleTile } from './RoleShell';

export default function Owner() {
  const navigate = useNavigate();

  return (
    <RoleLayout
      title="Panel — Owner"
      subtitle="Acceso completo a reservas, invitaciones, entradas y configuración general del sistema."
      roleLabel="Rol: Owner"
    >
      <RoleGrid><RoleTile label="Administración de consumo" onClick={()=>navigate('/admin/consumo')}/><RoleTile label="Roles y permisos" description="Permisos y accesos de cada rol." onClick={()=>navigate('/admin/roles')}/>
        <ActividadTile/><RoleTile label="Gestión de comisiones" description="Saldos y pagos por promotor y evento." onClick={()=>navigate('/admin/comisiones')}/>
        <RoleTile label="Historial y auditoría" description="Movimientos del sistema e históricos." onClick={()=>navigate('/admin/historial')}/>
        <RoleTile icon={FaBuilding} label="Estudio de recintos 3D" description="Diseña espacios, pisos y zonas; publica versiones por evento." onClick={()=>navigate('/admin/recintos')}/>

        <RoleTile
          icon={FaCalendarAlt}
          label="Reservas"
          description="Gestiona las mesas, lounges y estados de reserva."
          onClick={() => navigate('/dashboard/reservas')}
        />

        {/* ✅ NUEVO: Panel de administración de reservas */}
        <RoleTile
          icon={FaChartBar}
          label="Panel de Reservas"
          description="Administra reservas por evento (tabla, filtros, exportación y acciones)."
          onClick={() => navigate('/admin/reservas-panel')}
        />

        <RoleTile
          icon={FaTicketAlt}
          label="Generar entradas"
          description="Crea códigos QR de entrada para eventos específicos."
          // antes: '/entradas/generar'
          onClick={() => navigate('/entradas')}
        />
        <RoleTile
          icon={FaTicketAlt}
          label="Administrar entradas"
          description="Revisa, filtra y exporta todas las entradas generadas."
          onClick={() => navigate('/entradas/admin')}
        />
        <RoleTile
          icon={FaUserFriends}
          label="Generar invitaciones"
          description="Crea invitaciones con QR personalizadas por evento."
          onClick={() => navigate('/admin/generar-invitaciones')}
        />
        <RoleTile
          icon={FaUserFriends}
          label="Administrar invitaciones"
          description="Consulta, edita y exporta las invitaciones emitidas."
          onClick={() => navigate('/admin/invitaciones')}
        />
        <RoleTile
          icon={FaUsersCog}
          label="Promotores (RRPP / Imágenes)"
          description="Administra usuarios RRPP e Imagen registrados y sus accesos operativos."
          onClick={() => navigate('/admin/promotores')}
        />
        <RoleTile
          icon={FaQrcode}
          label="Escanear invitaciones"
          description="Acceso rápido al escáner de invitaciones en puerta."
          onClick={() => navigate('/escanear')}
        />
        <RoleTile
          icon={FaQrcode}
          label="Escanear entradas"
          description="Escanea entradas físicas y verifica su estado."
          onClick={() => navigate('/entradas/escanear')}
        />
        <RoleTile
          icon={FaUsersCog}
          label="Gestión de personal"
          description="Administra cuentas, roles y accesos del equipo."
          onClick={() => navigate('/dashboard/gestion-personal')}
        />
        <RoleTile
          icon={FaCogs}
          label="Paquetes de reserva"
          description="Panel para configurar paquetes, listas (viernes/sábado) y asignación por evento."
          onClick={() => navigate('/admin/reservas')}
        />

        <RoleTile
          icon={FaBuilding}
          label="Empresas"
          description="Administra clientes, empresas, usuarios y eventos de forma multiempresa."
          onClick={() => navigate('/empresas')}
        />
        <RoleTile
          icon={FaRegStar}
          label="Gestión de eventos"
          description="Crea y ajusta los eventos disponibles en Palmarama."
          onClick={() => navigate('/eventos')}
        />
      </RoleGrid>
    </RoleLayout>
  );
}
